import * as store from '../transitions/transitions';

export const RetireAddOnSteps = [
	'tax-income-status',
	'retire-income',
	'retire-ira-chooser',
	'e-sign',
	'auto-stash',
	'link-bank',
	'retire-complete-addon',
];

export const RetireAddOnTransitions = {
	'tax-income-status': [[store.hasFilingStatus, 'retire-income']],
	'retire-income': [[store.hasIncomeBracketOver6k, 'retire-ira-chooser']],
	'retire-ira-chooser': [[store.hasRetireAccountType, 'e-sign']],
	'e-sign': [[store.hasRetireEsig, 'auto-stash']],
	'auto-stash': [[store.hasAutoStash, 'link-bank']],
	'link-bank': [
		[store.skippedBankLinkRetireAddOn, 'retire-complete-addon'],
		[store.hasBankLinked, 'retire-complete-addon'],
	],
};

export default {
	name: 'RetireAddOnFlow',
	steps: RetireAddOnSteps,
	transitions: RetireAddOnTransitions,
	showProgressBarIcon: true,
};
